<template>
    <label class="file-select">
        <div class="select-button">
            {{ $t('upload') }}
        </div>
        <input type="file" @change="handleFileChange"/>
    </label>
</template>

<script>
    export default {
        name: "FileSelect",
        props: {
            value: File
        },
        methods: {
            handleFileChange(e) {
                this.$emit('input', e.target.files[0])
            }
        }
    }
</script>

<style scoped>
    .file-select > .select-button {
        width: 100px;
        padding: 12px 5px;
        color: white;
        background: #409eff;
        border-radius: 3px;
        text-align: center;
        font-weight: bold;
        display: inline-block;
        line-height: 1;
        cursor: pointer;
    }

    .file-select > input[type="file"] {
        display: none;
    }
</style>